import React from 'react';
import PageBanner from "@/components/pageBanner";
import {Heading} from "@/components/ui/heading";
import {Link} from "react-router-dom";
import Paths from "../constants/Paths";

const Training = () => {
    return (
        <>
            <PageBanner title="Training" slug="training"/>

            <section className="generic-container py-14 training-item">
                <div className={`text-center`}>
                    <Heading level={2} className={`gradient-header`}>
                        Invest in your knowledge
                    </Heading>
                </div>

                <p>
                    Join our training program, become a conscious investor and achieve success in trading.
                </p>

                <div className="video-container">
                    <iframe
                        width="560"
                        height="315"
                        src="https://www.youtube.com/embed/cIHONxhDt7c"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    ></iframe>
                </div>

                <div className={`text-center mt-12`}>
                    <Link to="mailto:office@lockedtrade.com" className="big-button dark-variant mx-auto mt-3">JOIN NOW!</Link>
                </div>

            </section>

            <section className="py-14 dark-bg-with-gradients">
                <div className='generic-container'>

                    <Heading level={2} className={`big-white-header`}>
                        Methods of forex market analysis
                    </Heading>

                    <p className={`text-white text-center mt-8`} style={{fontSize: '24px'}}>
                        Achieving profitability in the Forex market is impossible without conducting a thorough analysis
                        of the current market situation and identifying trends over various timeframes. Therefore,
                        traders utilize a range of tools and both fundamental and technical analysis methods to forecast
                        future price movements.
                    </p>

                    <p className={`text-white text-center mt-8 text-xl`} style={{fontSize: '24px'}}>
                        To conduct an effective market analysis, a trader must examine the factors influencing market
                        conditions and the formation of new trends within a given currency pair.
                    </p>

                    <Heading level={2} className={`big-white-header mt-12`}>
                        Types of market analysis
                    </Heading>

                    <p className={`text-white text-center mt-4`} style={{fontSize: '24px'}}>
                        Financial markets primarily rely on two types of analysis:
                    </p>

                    <div className={`grid grid-cols-1 lg:grid-cols-2 gap-24 mt-8`}>
                        <Link to={Paths.TRAINING_FUNDAMENTAL_ANALYSIS} className={`market-box`}>
                            <Heading level={3} className={`market-box--title`}>
                                Fundamental Analysis
                            </Heading>
                            <p className={`market-box--content`}>
                                A method of predicting future exchange rates based on macroeconomic data, which is
                                closely linked to overall economic conditions.
                            </p>
                            <button className="big-button dark-variant">GET MORE</button>
                        </Link>
                        <Link to={Paths.TRAINING_TECHNICAL_ANALYSIS} className={`market-box`}>
                            <Heading level={3} className={`market-box--title`}>
                                Technical Analysis
                            </Heading>
                            <p className={`market-box--content`}>
                                A method of forecasting future price movements based on historical price changes.
                            </p>
                            <button className="big-button dark-variant">GET MORE</button>
                        </Link>
                    </div>

                    <p className={`text-white text-center mt-8`} style={{fontSize: '24px'}}>
                        While proponents of technical analysis argue that all necessary information is embedded in price
                        charts, fundamental analysis encompasses a broader range of economic aspects, including
                        political, social, and macroeconomic factors, as well as corporate earnings data. Fundamental and technical analyses are not mutually exclusive. In practice, employing both
                        approaches can yield the most comprehensive insights.
                    </p>

                </div>
            </section>

            <section className="generic-container py-14 training-item">
                <div className={`text-center`}>
                    <Heading level={2} className={`gradient-header`}>
                        Types of positions in the forex market.
                    </Heading>
                </div>

                <p className={`text-lt-dark-blue text-center`} style={{fontSize: '24px', marginTop: '1rem'}}>
                    In the Forex market, there are two primary types of positions:
                </p>

                <div className={`grid grid-cols-1 lg:grid-cols-2 gap-24 mt-8`}>
                    <Link to={Paths.TRAINING_LONG_POSITION} className={`market-box`}>
                        <Heading level={3} className={`market-box--title`} style={{lineHeight: '1'}}>
                            Long Position<br/>(Buy Transaction)
                        </Heading>
                        <p className={`market-box--content`}>
                            A position taken in anticipation of an increase in the exchange rate.
                        </p>
                        <button className="big-button dark-variant">GET MORE</button>
                    </Link>
                    <Link to={Paths.TRAINING_SHORT_POSITION} className={`market-box`}>
                        <Heading level={3} className={`market-box--title`}>
                            Short Position<br/>(Sell Transaction)
                        </Heading>
                        <p className={`market-box--content`}>
                            A position taken to profit from a decline in the exchange rate.
                        </p>
                        <button className="big-button dark-variant">GET MORE</button>
                    </Link>
                </div>

                <div className={`text-center mt-12`}>
                    <Link to="mailto:office@lockedtrade.com" className="big-button dark-variant mx-auto mt-3">JOIN NOW!</Link>
                </div>

            </section>
        </>
    );
};

export default Training;